export default {
  fields: {
    email: 'Email address',
    postcode: 'Postcode',
    title: 'Title',
    firstName: 'First name',
    lastName: 'Last name',
    mobilePhone: 'Mobile phone',
    dateOfBirth: 'Date of birth',
    birthday: 'Birthday',
    fullAddress: 'Full Address',
    accept: {
      0: 'I accept the',
      1: 'I am over 13 and accept the',
      2: 'I am over 16 and accept the',
      3: 'I am over 18 and accept the',
      4: 'I am over 21 and accept the'
    }
  }
};